module.exports = __webpack_public_path__ + "img/rule1.44bfa892.png";